import React from 'react';
import ConnectorEmptyState from './ConnectorEmptyState';

export interface ConnectorSelectIntegrationPromptProps {
  description: string;
  icon?: string;
  onGoToIntegrations: () => void;
}

const ConnectorSelectIntegrationPrompt: React.FC<ConnectorSelectIntegrationPromptProps> = ({
  description,
  icon = 'fa-plug',
  onGoToIntegrations,
}) => {
  return (
    <div className="connector-select-integration-prompt">
      <ConnectorEmptyState
        icon={icon}
        title="Select an integration"
        description={description}
        action={
          <button
            type="button"
            className="connector-shell-btn connector-shell-btn--primary"
            onClick={onGoToIntegrations}
          >
            <i className="fas fa-arrow-right" aria-hidden />
            Go to Integrations
          </button>
        }
      />
      <div className="connector-select-integration-prompt__steps" aria-hidden>
        <span>1. Open Integrations</span>
        <i className="fas fa-chevron-right" />
        <span>2. Select a card</span>
        <i className="fas fa-chevron-right" />
        <span>3. Return here</span>
      </div>
    </div>
  );
};

export default ConnectorSelectIntegrationPrompt;
